// ダッシュボード等の「同一パスでクエリ文字列だけ変わる」絞り込み遷移で、
// 閲覧中のスクロール位置を維持する。
//
// Turbo Drive はページ遷移のたびに body を差し替えるため、デスクトップで
// 実スクロール要素になっている <main data-scroll-container>（md:overflow-y-auto）
// が毎回 scrollTop=0 の新要素に置き換わり、見ていた位置が最上部へ飛んでしまう。
//
// 対策として遷移開始直前（turbo:before-visit／旧DOMが残っている時点）のスクロール
// 位置を保存し、遷移完了後（turbo:load）に同一パスであれば復元する。
// 通常のページ間遷移（パスが変わる）や戻る/進むでは従来どおりの挙動に任せる。
//
// 対象ページは data-preserve-scroll 目印を持つページのみ（オプトイン）。

// 保存した遷移直前の状態 { path: 旧パス, top: スクロール量 }。未保存時は null。
let pendingScroll = null

// 実スクロール要素を返す。デスクトップは <main data-scroll-container>、
// モバイル（body がスクロール）の場合は null を返し window を使う。
//
// <main> は md:overflow-y-auto のため md 未満では overflow-y が visible で実際には
// スクロールしない（body がスクロールする）。要素の有無だけで判定すると、モバイルでも
// 常に scrollTop=0 の <main> を返してしまい保存・復元が機能しないため、computed style の
// overflow-y が実際にスクロール可能な場合のみその要素を返す。
function scrollContainer() {
  const container = document.querySelector("main[data-scroll-container]")
  if (container) {
    const overflowY = window.getComputedStyle(container).overflowY
    if (overflowY === "auto" || overflowY === "scroll") {
      return container
    }
  }
  return null
}

// 遷移開始直前に呼ばれ、オプトインページなら現在のスクロール位置を保存する。
// ブラウザの戻る/進む（restoration visit）では Turbo 標準の履歴スクロール復元に
// 任せたいため保存しない（誤復元を防ぐため pendingScroll もクリアする）。
function captureScroll(event) {
  if (event.detail && event.detail.action === "restore") {
    pendingScroll = null
    return
  }
  if (!document.querySelector("[data-preserve-scroll]")) return
  const container = scrollContainer()
  pendingScroll = {
    path: window.location.pathname,
    top: container ? container.scrollTop : window.scrollY
  }
}

// 遷移開始を捕捉する。カスタム期間の GET フォーム送信も Turbo では通常の Visit
// として扱われ turbo:before-visit が発火するため、これだけで過不足なく捕捉できる。
document.addEventListener("turbo:before-visit", captureScroll)

document.addEventListener("turbo:load", () => {
  // 同一パス（クエリだけ変わった絞り込み）のときだけ位置を復元する。
  if (pendingScroll && pendingScroll.path === window.location.pathname) {
    const container = scrollContainer()
    if (container) {
      container.scrollTop = pendingScroll.top
    } else {
      window.scrollTo(0, pendingScroll.top)
    }
  }
  pendingScroll = null
})
